import React, { useEffect, useRef, useState } from 'react';
import '../App.css';
import './footer.css';
/*import TengucuteImage from '../images/tengulogocute.png';*/
/*import Tengu from '../images/Tengu_Mask_Tech Logo_Design2.png';*/
import Crow_Logo from '../images/new_crow_logo5.png';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import useFluidSmoke from './footer2.js'
import { motion } from 'framer-motion';


const useFooter = () => {
  const getCurrentYear = () => new Date().getFullYear();

  return {
    currentYear: getCurrentYear(),
  };
};

const Footer = () => {
  const { currentYear } = useFooter();
  const [isVisible, setIsVisible] = useState(false);
  const footerDivRef = useRef(null);
  const footerRef = useRef(null);
  const canvasRef = useRef(null);

  


  const handleScroll = () => {
    if (footerDivRef.current) {
      const elementTop = footerDivRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Adjust this value to control when the slide-in should start
      const triggerOffset = 100;

      if (elementTop < windowHeight - triggerOffset) {
        setIsVisible(true);
        console.log( "element triggered" )
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check visibility on initial render
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /*useEffect(() => {
    const footer = footerRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let particlesArray = [];
    const mouse = { x: 0, y: 0 };

    canvas.width = footer.offsetWidth;
    canvas.height = footer.offsetHeight;

    window.addEventListener('resize', () => {
      canvas.width = footer.offsetWidth;
      canvas.height = footer.offsetHeight;
    });

    /*const createParticle = (x, y) => {
      const particle = {
        x,
        y,
        size: Math.random() * 5 + 1,
        speedX: Math.random() * 2 - 1,
        speedY: Math.random() * 2 - 1,
        alpha: 1,
        life: Math.random() * 10 + 20,
      };
      particlesArray.push(particle);
    };*/

    /*const createParticle = (x, y) => {
  // isotropic direction
  const angle = Math.random() * Math.PI * 2;          // 0..2π
  const mag   = 0.15 + Math.random() * 0.35;          // tiny radial speed
  const up    = 0.25 + Math.random() * 0.20;          // upward bias

  const particle = {
    x,
    y,
    size: Math.random() * 1 + 1,                      // tiny (1–3px)
    // mostly upward, but not axis-aligned
    speedX: Math.cos(angle) * mag,
    speedY: -up + Math.sin(angle) * (mag * 0.25),
    alpha: 0.5 + Math.random() * 0.3,
    life: Math.random() * 60 + 120,
    seed: Math.random() * 1000                        // per-particle phase for curl
  };
  particlesArray.push(particle);
};


    /*const createParticle = (x, y) => {
  const particle = {
    x,
    y,
    size: Math.random() * 5 + 1,          // smaller start (2–8px)
    speedX: (Math.random() - 0.5) * 0.5,   // gentle horizontal drift
    speedY: -(0.2 + Math.random() * 0.4),  // upward motion
    alpha: 0.55 + Math.random() * 0.05,      // semi-transparent to start
    life: Math.random() * 60 + 120          // lingers longer = clumpy overlap
  };
  particlesArray.push(particle);
};*/


    /*const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
      for (let i = 0; i < 20; i++) {
        createParticle(mouse.x, mouse.y);
      }
    };

    const handleTouchMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const touch = e.touches[0]; // Handle the first touch point
      mouse.x = touch.clientX - rect.left;
      mouse.y = touch.clientY - rect.top;
      for (let i = 0; i < 20; i++) {
        createParticle(mouse.x, mouse.y);
      }
    };*/

    /*const BURST = 200; // number of particles per mouse/touch move

const handleMouseMove = (e) => {
  const rect = footer.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  // 🔥 create multiple particles per event
  for (let i = 0; i < BURST; i++) {
    createParticle(x, y);
  }
};

const handleTouchMove = (e) => {
  const rect = footer.getBoundingClientRect();
  const touch = e.touches[0] || e.changedTouches[0];
  const x = touch.clientX - rect.left;
  const y = touch.clientY - rect.top;

  for (let i = 0; i < BURST; i++) {
    createParticle(x, y);
  }
};



   const updateParticles = () => {
      for (let i = 0; i < particlesArray.length; i++) {
        const p = particlesArray[i];
        p.x += p.speedX;
        p.y += p.speedY;
        // --- lightweight curl field (fluid look, no heavy noise) ---
const curlX = Math.sin((p.y + p.seed) * 0.02) * 0.02;
const curlY = -Math.cos((p.x + p.seed) * 0.02) * 0.015;

// blend curl into velocity + very light damping + gentle rise
p.speedX = (p.speedX + curlX) * 0.992;
p.speedY = (p.speedY + curlY - 0.006) * 0.996;

// microscopic Brownian jitter (prevents gridiness; keep tiny)
p.speedX += (Math.random() - 0.5) * 0.002;
p.speedY += (Math.random() - 0.5) * 0.002;

        p.alpha -= 0.006;
        if (p.alpha <= 0) {
          particlesArray.splice(i, 1);
          i--;
        }
      }
    };

    /*const updateParticles = () => {
  for (let i = 0; i < particlesArray.length; i++) {
    const p = particlesArray[i];

    // original motion
    p.x += p.speedX;
    p.y += p.speedY;

    // --- add these for smoke motion ---
    p.y -= 0.012;                                   // gentle upward drift
    p.speedX += Math.sin(p.y * 0.01) * 0.005;      // subtle curl
    p.speedY += Math.cos(p.x * 0.01) * 0.01 - 0.01; // tiny turbulence + rise accel

    // optional: slight growth + fade so puffs feel smoky (keep if you already do this elsewhere)
    if (p.size != null) p.size += 0.01;
    p.alpha -= 0.003;

    // your original removal (keep)
    if (p.alpha <= 0 || !isFinite(p.x) || !isFinite(p.y)) {
      particlesArray.splice(i, 1);
      i--;
    }
  }
};*/


    /*const drawParticles = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';
      for (const p of particlesArray) {
        //ctx.fillStyle = `rgba(148, 0, 211, ${p.alpha})`;
       // ctx.fillStyle = `rgba(144, 77, 78, ${p.alpha})`;
        ctx.fillStyle = `rgba(220, 220, 220, ${p.alpha})`;
        //ctx.shadowBlur = 15;
        ctx.shadowColor = `rgba(144, 77, 78, ${p.alpha})`;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
      }
    };

    // FAST SMOKE — drop-in for your existing drawParticles
/*const drawParticles = () => {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const prevComp = ctx.globalCompositeOperation;
  ctx.globalCompositeOperation = 'screen'; // soft, non-bubbly blend

  // vertical stretch so puffs read as smoke (not dots)
  const stretchY = 1.85;

  for (let i = 0; i < particlesArray.length; i++) {
    const p = particlesArray[i];
    if (!p) continue;

    const r = p.size;                 // your radius
    const a = p.alpha ?? 0.22;        // your alpha (fallback if missing)

    // small direction hint (align a bit with motion so it plumes)
    const vx = p.vx || 0, vy = (p.vy || 0) - 0.18; // slight rise bias
    const ang = Math.atan2(vy, vx) * 0.2;          // gentle rotation, not expensive

    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(ang);
    ctx.scale(1, stretchY);

    // single radial gradient per particle (cheap)
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
    g.addColorStop(0.00, `rgba(238,238,238,${a})`);
    g.addColorStop(0.45, `rgba(215,215,215,${a * 0.55})`);
    g.addColorStop(1.00, `rgba(190,190,190,0)`);

    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(0, 0, r, 0, Math.PI * 2);
    ctx.fill();

    ctx.restore();
  }

  ctx.globalCompositeOperation = prevComp || 'source-over';
};*/

/*const drawParticles = () => {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.globalCompositeOperation = 'screen'; // softer blend for smoke

  for (let i = 0; i < particlesArray.length; i++) {
    const p = particlesArray[i];
    if (!p) continue;

    // make them look fuzzy and smoky using a gradient
    const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * 10);
    g.addColorStop(0.0, `rgba(235,235,235,${p.alpha * 0.9})`);
    g.addColorStop(0.3, `rgba(215,215,215,${p.alpha * 0.1})`);
    g.addColorStop(1.0, `rgba(190,190,190,0)`);

    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(p.x, p.y, p.size * 2.4, 0, Math.PI * 2);
    ctx.fill();
  }

  ctx.globalCompositeOperation = 'source-over';
};*/



    /*const animate = () => {
      updateParticles();
      drawParticles();
      requestAnimationFrame(animate);
    };

    footer.addEventListener('mousemove', handleMouseMove);
    footer.addEventListener('touchmove', handleTouchMove); // Add touchmove event
    footer.addEventListener('touchstart', handleTouchMove); // Add touchstart event
    animate();

    return () => {
      footer.removeEventListener('mousemove', handleMouseMove);
      footer.removeEventListener('touchmove', handleTouchMove);
      footer.removeEventListener('touchstart', handleTouchMove);
    };
  }, []);*/
  
useFluidSmoke(canvasRef, footerRef);

  return (
    <footer id='footer1' ref={footerRef}>
      <canvas ref={canvasRef} id="waterCanvas"></canvas>

      
      
      <div id="footerdiv1" className={`slide-in-div-footer ${isVisible ? 'visible' : ''}`}
        ref={footerDivRef}>
                <div id="tengucute_div">
                  <img id='tengucute_image' src={Crow_Logo} alt="TengucuteImage"/>
                </div>
                <div id="yokaifooter_header">
                  <p>Yokai</p>
                </div>
                <div id='footerdiv2'>
                  <p id="softwarelogo">Software and Web Development</p>
                </div>
                <div id='footerdiv3'>
                  <p>Look for us on these social media platforms</p>
                </div>
                <div id='footerdiv4'>
                  <div id='yokaifooter_header2'> <h2>Contact Us</h2></div>
                  <div id='footer_contactinfo'>
                    <p>phone: 941-613-4645</p>
                    <p>email: yokaisoftware66@gmail.com</p>
                  </div>
                </div>
                <div id='footerdiv5'>
                      <a href="/ContactPage">
                      <motion.div
                        id='href_footer'
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.8 }}
                        >Let's Get Started!
                      </motion.div></a>
                </div>
                <div id="social-icons">
                  <a id='fafacebook' href="https://www.facebook.com/profile.php?id=61559579340148&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                    <FaFacebook size={50} className="facebook" />
                  </a>
                  <a href="https://www.instagram.com/yokaisoftware?igsh=MTBjbWhiM294NXNxbA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={50} className="instagram" />
                  </a>
                  <a href="https://www.linkedin.com/company/yokai-software-and-web-development/about/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={50} className="linkedin" />
                  </a>
                </div>
            <div id='copyright'>
                <p>Copyright © {currentYear} Yokai Software</p>
            </div>
      </div>
    </footer>
  );
};

export default Footer;


//style={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}